import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/settings/groups/get-group-types';

  return API({ endpoint });
}
